import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@mui/styles";
import { Snackbar } from "@mui/material";
import { IconButton } from "@mui/material";
// @material-ui/icons
import Close from '@mui/icons-material/Cancel';
// core components
import styles from "../../assets/jss/psstyle/component/snackbarContentStyle";
import MuiAlert from '@mui/material/Alert';

const useStyles = makeStyles(styles);

export default function CustomSnackbar(props) {
  const classes = useStyles();
  const { message, color, close, icon, place, open, rtlActive, autoClose } = props;
  var action = [];
  const messageClasses = classNames({
    [classes.iconMessage]: icon !== undefined
  });

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  if (close !== undefined) {
    action = [
      <IconButton
        className={classes.iconButton}
        key="close"
        aria-label="Close"
        color="inherit"
        onClick={() => props.closeNotification()}
      >
        <Close className={classes.close} />
      </IconButton>
    ];
  }

  return (
    <Snackbar open={open} autoHideDuration={autoClose !== "" ? autoClose : 3600} onClose={() => props.closeNotification()}
      anchorOrigin={{
        vertical: place.indexOf("t") === -1 ? "bottom" : "top",
        horizontal:
          place.indexOf("l") !== -1
            ? "left"
            : place.indexOf("c") !== -1
              ? "center"
              : "right"
      }}
    >
      <Alert onClose={() => props.closeNotification()} severity={color} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar >
  );
}

Snackbar.propTypes = {
  message: PropTypes.node.isRequired,
  color: PropTypes.oneOf(["info", "success", "warning", "danger", "primary"]),
  close: PropTypes.bool,
  icon: PropTypes.object,
  place: PropTypes.oneOf(["tl", "tr", "tc", "br", "bl", "bc"]),
  open: PropTypes.bool,
  rtlActive: PropTypes.bool,
  closeNotification: PropTypes.func,
  autoClose: PropTypes.number
};

Snackbar.defaultProps = {
  open: false,
  rtlActive: false,
  autoClose: 3600,
  close: false,
  message: ""
}